import { render, staticRenderFns } from "./add-providers.vue?vue&type=template&id=20ece2e9&scoped=true&"
import script from "./add-providers.vue?vue&type=script&lang=js&"
export * from "./add-providers.vue?vue&type=script&lang=js&"
import style0 from "./add-providers.vue?vue&type=style&index=0&id=20ece2e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ece2e9",
  null
  
)

export default component.exports